import React from "react";
import Header from "../../components/header";
import News from "../../components/news";
import NavBar from "../../components/navBar";
import * as GS from "../../utils/globalStyles/background";

const NewsPage: React.FC = () => {
  return (
    <GS.BackgroundApp>
      <Header />
      {/* <News /> */}
      <GS.BodyContainer>
        <News />
      </GS.BodyContainer>
      {/* <NavBar /> */}
      <GS.NavContainer>
        <NavBar />{" "}
      </GS.NavContainer>
    </GS.BackgroundApp>
  );
};

export default NewsPage;
